<style>

.info-box{
  display: grid;
  grid-template-columns: 45px auto 32px;
  background-color: white;
  color: black;
  border-radius: 5px;
  margin-bottom: 5px;
  padding: 10px 3px 9px 3px;
  align-items: center;
}
.info-box-icon{
  grid-column: 1;
  text-align: center;
}
.info-box-text{
  grid-column: 2;
  font-size: 19px;
  margin-left: 10px;
}
.info-box-arrow{
  grid-column: 3;
}
[class^="icon-"] {
  font-size: 30px;
  color: #696969;
}

</style>

<div class="info-box" on:click="{ () => { dispatch(callback) } }">
  <div class="info-box-icon"> <i class="{actualIcon}"></i> </div>
  <div class="info-box-text"><slot></slot></div>
  <div class="info-box-arrow"> <i class="icon-arrow_right"></i> </div>
</div>


<script>

import { createEventDispatcher } from 'svelte';
const dispatch = createEventDispatcher();

export let icon = "website";
export let callback = "infoBoxClicked";


let actualIcon = "";

$: {
  // translate icon text into actual icon
  if (icon) {
    if (icon == "website") actualIcon = "icon-globe";
    if (icon == "address") actualIcon = "icon-location_on";
    if (icon == "phone") actualIcon = "icon-call";
    if (icon == "price") actualIcon = "icon-attach_money";
    if (icon == "facebook") actualIcon = "icon-facebook";
    if (icon == "instagram") actualIcon = "icon-instagram";
    if (icon == "linkedin") actualIcon = "icon-linkedin";
    if (icon == "snapchat") actualIcon = "icon-snapchat";
    if (icon == "twitter") actualIcon = "icon-twitter";
  }
}

</script>